
Vue.component("courseware_screenshoot_panel", {
  mounted() {
  },
  props: {
    player: {
      default: null
    },
  },
  data() {
    return {
      list: [],
      contentId: '',
      total: 0,
      selected: ''
    }
  },
  methods: {
    async init(contentIds) {
      // contentIds = contentIds.filter(el => (el.seat == '屏幕画面' || el.seat == '导切画面')).map(el => el.contentId)
      contentIds = contentIds.map(el => el.contentId)
      if (!contentIds.length) return this.$emit('gettotal', 0)
      for (let i = 0; i < contentIds.length; i++) {
        this.contentId = contentIds[i]
        const list = await this.getList(1)
        if (list.length) break
      }

    },
    getList(page) {
      const that = this
      return new Promise((resolve) => {
        API.reqCoursewareImgList({ contentId: that.contentId, page, size: 10 }).then(res => {
          if (res.success && res.data && res.data.recordTotal) {
            that.list = res.data.data
            that.total = res.data.recordTotal
            that.$emit('gettotal', that.total)
            resolve(that.list)
          } else {
            resolve([])
            that.$emit('gettotal', 0)
          }
        }).catch(() => {
          resolve([])
          that.$emit('gettotal', 0)
        })
      })
    },
    handleSelect(item) {
      this.selected = item.fileGUID
      let currentTime = TimeCodeConvert.frame2Second(item.keyFrameNo, 25)
      this.$emit('seek', { currentTime })
    },
    timeFormat(time) {
      return TimeCodeConvert.frame2Tc(time, 25, false)
    }
  },
  template: `
  <div class="courseware_screenshoot_panel">
      <div class="list">
        <div class="courseware_screenshoot_item" :class="{active:selected == item.fileGUID}" v-for="(item,i) in list" :key="item.fileGUID" @click="handleSelect(item)">
            <div class="item_left">
                <div class="time">{{timeFormat(item.keyFrameNo)}}</div>
            </div>
            <div class="item_right">
                <div class="index">{{i + 1}} {{item.fromFileGUID === 'screenshot'? '手动生成': '智能识别'}}</div>
                <img :src="item.filePath" alt="">
            </div>
        </div>
      </div>
      <el-pagination @current-change="getList" :total="total" layout="total, prev, pager, next" small hide-on-single-page></el-pagination>
  </div>
  `,
});